import '../css/style.css';
import './navigation.js';

class FoundationTheme {
	constructor() {
		if ( document.readyState === 'loading' ) {
			document.addEventListener( 'DOMContentLoaded', () => this.onReady() );
		} else {
			this.onReady();
		}
	}

	onReady() {
		const skipLink = document.querySelector( '.skip-link' );
		if ( skipLink ) {
			skipLink.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				const target = document.querySelector( skipLink.getAttribute( 'href' ) );
				if ( target ) {
					target.focus();
					target.scrollIntoView( { behavior: 'smooth' } );
				}
			} );
		}
	}
}

new FoundationTheme();
